
<template>
    <div>
        <ion-toolbar>
            <ion-buttons slot="start">
                <ion-button class="button_back" @click="goBack">
                    <ion-icon name="arrow-back-outline"></ion-icon>
                </ion-button>
            </ion-buttons>
            <ion-title>Job Alerts</ion-title>
        </ion-toolbar>
        <div class="main_wrapper ion_padding">
            <div class="container">
                <p class="text-center">Please enter job alert details</p>
                <el-form class="full_page" :model="form" label-position="top">
                    <div class="job_row">
                        <div class="job_row--content">
                            <el-form-item class="no-scroll" label="Category" prop="jobTitles">
                                <el-checkbox-group class="job-title-checkbox-select" v-model="form.jobTitles">
                                    <el-checkbox v-for="item in jobTitleOptions" :key="item" :label="item">
                                        {{ item }}
                                    </el-checkbox>
                                </el-checkbox-group>
                                <el-form-item-error v-if="v$.jobTitles.$error">{{
                                    v$.jobTitles.$errors[0].$message
                                }}</el-form-item-error>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="job_row">
                        <div class="job_row--content">
                            <el-form-item label="Location" :show-message="false" class="no-scroll">
                                <div class="el-input el-input--prefix">
                                    <vue-google-suburb-autocomplete id="map" classname="el-input__inner"
                                        placeholder="City and State" v-on:placechanged="setAddressData"
                                        :country="countryArray" :initialLocation="form.jobLocation.address"
                                        v-model="form.jobLocation.address" :key="addressComponent">
                                    </vue-google-suburb-autocomplete>
                                    <span class="el-input__prefix">
                                        <i class="el-input__icon el-icon-search" />
                                    </span>
                                </div>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="job_row">
                        <div class="job_row--content">
                            <el-form-item class="no-scroll" label="Distance from Location" prop="distance">
                                <el-input-number v-model="form.distance" :controls="false" :placeholder="jobDistancePlaceholder" />
                                <el-form-item-error v-if="v$.distance.$error">{{
                                    v$.distance.$errors[0].$message
                                }}</el-form-item-error>
                            </el-form-item>
                        </div>
                    </div>

                    <div class="job_row">
                        <div class="job_row--content">
                            <el-form-item class="no-scroll" label="Work Type" prop="jobTypes">
                                <el-checkbox-group v-model="form.jobTypes">
                                    <el-checkbox v-for="item in jobTypeOptions" :key="item" :label="item">
                                        {{ item }}
                                    </el-checkbox>
                                </el-checkbox-group>
                                <el-form-item-error v-if="v$.jobTypes.$error">{{
                                    v$.jobTypes.$errors[0].$message
                                }}</el-form-item-error>
                            </el-form-item>
                        </div>
                    </div>

                    <div class="job_row">
                        <div class="job_row--content">
                            <el-form-item class="no-scroll salary-range" label="Salary Range">
                                <el-checkbox v-for="(label, value) in paymentOptions" :key="value" :label="label"
                                
                                    :value="value" @change="salaryRangeCheckboxChange(value, $event)" :checked="form.salaryRange[value].minRate !==null">
                                    {{ label }}
                                    <div class="salary-range-input-block">
                                        <el-input v-model="form.salaryRange[value].minRate"
                                        @keyup="handleSalaryInput($event.target.value, value)"
                                         :placeholder="`Minimum ${value == 'hourly' ? 'Hourly' : 'Annual'} Rate`"
                                            :disabled="disabledSalaryRange[value]" />
                                    </div>
                                    <div v-if="value == 'hourly'">
                                        <el-form-item-error v-if="v$.salaryRange.hourly.$errors.length > 0">{{
                                        v$.salaryRange.hourly.$errors[0].$message
                                    }}</el-form-item-error>
                                    </div>
                                    <div v-if="value == 'annual'">
                                        <el-form-item-error v-if="v$.salaryRange.annual.$errors.length > 0">{{
                                        v$.salaryRange.annual.$errors[0].$message
                                    }}</el-form-item-error>
                                    </div>
                                </el-checkbox>
                               
                            </el-form-item>
                        </div>
                    </div>

                    <div class="job_row">
                        <div class="job_row--content">
                            <el-form-item class="no-scroll" label="Frequency">
                                <el-radio-group v-model="form.frequency">
                                    <el-radio :label="value" v-for="(frequency, value) in frequencyOptions"
                                        :key="value">{{ frequency }}</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                    </div>

                    <div class="job_row" v-if="isGuest">
                        <div class="job_row--content">
                            <el-form-item class="no-scroll" label="Enter your email address">
                                <el-input email v-model="form.email" placeholder="Add Your Email Address" />
                                <el-form-item-error v-if="v$.email.$error">{{
                                    v$.email.$errors[0].$message
                                }}</el-form-item-error>
                            </el-form-item>
                        </div>
                    </div>

                    <el-form-item class="button_submit mb0">
                        <el-button @click="onSubmit()" class="submit">
                            <span>Save Subscription</span>
                        </el-button>
                    </el-form-item>
                    <!-- <p @click="unsubscribeJobAlerts" v-if="alreadySubscribed" class="text-center mt-3">Unsubscribe</p> -->
                </el-form>
            </div>
        </div>
    </div>
</template>

<script setup>
import { reactive, onMounted, ref, computed, inject } from "vue";
import { useStore } from "vuex";
import { ElMessage } from "@/components/Vendor/Element";
import { useRouter } from "vue-router";
import { useVuelidate } from "@vuelidate/core";
import { required, helpers } from "@vuelidate/validators";
import { VueGoogleSuburbAutocomplete } from "@/components/components";

const $store = useStore();
const $router = useRouter();
const userData = $store.getters.GET_USER_DATA;
const userRole = userData.role
// const isGuest = computed(() => !userData?.jobSeekerRoleEnabled);
const isGuest = computed(() => !userData);
const alreadySubscribed = ref(false)
const messages = inject("messages");

const form = reactive({
    jobTitles: [],
    jobLocation: {
        address: "",
        lat: "",
        lng: "",
    },
    distance: "",
    jobTypes: [],
    salaryRange: {
        hourly: {
            minRate: null,
        },
        annual: {
            minRate: null,
        },
    },
    frequency: "daily",
    email: "",
});

const rules = computed(() => {
    return {
        jobTypes: {
            required: helpers.withMessage("Please select work type", required),
        },
        jobTitles: {
            required: helpers.withMessage("Please select job category", required),
        },
        email: {
            required: isGuest.value
                ? helpers.withMessage("Please enter email address", required)
                : false,
            email: isGuest.value
                ? helpers.withMessage("Please enter a valid email address", required)
                : false,
        },
        distance: {
            min: false,
        },
        salaryRange: {
            hourly: {
                required: helpers.withMessage(
                    "Please enter minimum hourly rate",
                    (value) => disabledSalaryRange.hourly || (value.minRate)
                ),
                minRate: helpers.withMessage(
                    "Minimum Hourly rate must be a number",
                    (value) => !isNaN(value.minRate)
                ),
                validDecimal: helpers.withMessage(
                    "Minimum hourly rate should have maximum 2 decimal places",
                    (value) => {
                        // Check if minRate exists and is a number
                        if (value.minRate && !isNaN(value.minRate)) {
                            const minRateStr = value.minRate.toString();
                            
                            // Check if the number ends with a decimal point
                            if (minRateStr.endsWith(".")) {
                                return false; // Fails validation if it ends with a decimal point
                            }

                            // Only check for decimal places if there is a decimal
                            const decimalPart = minRateStr.split(".")[1];
                            return !decimalPart || decimalPart.length <= 2;
                        }
                        return true; // Pass the validation if minRate is not present or invalid
                    }
                ),
            },
            annual: {
                required: helpers.withMessage(
                    "Please enter minimum annual rate",
                    (value) => disabledSalaryRange.annual || (value.minRate)
                ),
                minRate: helpers.withMessage(
                    "Minimum Annual rate must be a number",
                    (value) => !isNaN(value.minRate)
                ),
                validDecimal: helpers.withMessage(
                    "Minimum annual rate should have maximum 2 decimal places",
                    (value) => {
                        // Check if minRate exists and is a number
                        if (value.minRate && !isNaN(value.minRate)) {
                            const minRateStr = value.minRate.toString();
                            
                            // Check if the number ends with a decimal point
                            if (minRateStr.endsWith(".")) {
                                return false; // Fails validation if it ends with a decimal point
                            }

                            // Only check for decimal places if there is a decimal
                            const decimalPart = minRateStr.split(".")[1];
                            return !decimalPart || decimalPart.length <= 2;
                        }
                        return true; // Pass the validation if minRate is not present or invalid
                    }
                ),
            },
        },
    };
});

const v$ = useVuelidate(rules, form);

const jobTypeOptions = ref([]);
const jobTitleOptions = ref([]);
const paymentOptions = ref([]);
const frequencyOptions = ref([]);
const disabledSalaryRange = reactive({
    hourly: true,
    annual: true,
});
const addressComponent = ref(0)
const isUpdate = ref(false)

const fetchData = () => {
    $store
        .dispatch("GET_SUBSCRIBE_JOBS_DATA", { isGuest: isGuest.value })
        .then((response) => {
            jobTypeOptions.value = response.jobTypeOptions || [];
            jobTitleOptions.value = response.jobTitleOptions || [];
            paymentOptions.value = response.paymentOptions || [];
            frequencyOptions.value = response.frequencyOptions || [];
            Object.assign(form, response.subscriptionSettings);

            if(response.subscriptionSettings) {
                isUpdate.value = true
            }

            form.salaryRange = {
                hourly: {
                    minRate: response.subscriptionSettings.salaryRange?.hourly?.minRate || null,
                },
                annual: {
                    minRate: response.subscriptionSettings.salaryRange?.annual?.minRate || null,
                },
            };

            if (response.subscriptionSettings.salaryRange) {
                Object.keys(response.subscriptionSettings.salaryRange).forEach(
                    (key) => {
                        if (
                            response.subscriptionSettings.salaryRange[key].minRate
                        ) {
                            disabledSalaryRange[key] = false;
                        }
                    }
                );
            }

            addressComponent.value = +1
            if (response.subscriptionSettings) {
                alreadySubscribed.value = true
            }
        })
        .catch((error) => {
            console.error("Error fetching subscription data:", error);
        });
};

// const unsubscribeJobAlerts = () => {
//     $store
//         .dispatch("UNSUBSCRIBE_JOB_ALERT")
//         .then((response) => {
//             if (response.success) {
//                 ElMessage({
//                     type: "success",
//                     message: response.message,
//                 });
//                 goBack();
//             }
//         });
// };

onMounted(() => {
    fetchData();
});


const onSubmit = () => {
    v$.value.$touch();

    if (v$.value.$invalid) {
        return;
    }

    if (disabledSalaryRange.hourly) {
        delete form.salaryRange.hourly
    }

    if (disabledSalaryRange.annual) {
        delete form.salaryRange.annual
    }

    if(isUpdate.value){
        form.isUpdate = true
    }

    $store
        .dispatch("UPDATE_SUBSCRIBE_JOBS_DATA", {
            formData: form,
            isGuest: isGuest.value,
        })
        .then((response) => {
            if (response.success) {
                ElMessage({
                    type: "success",
                    message: response.message,
                });
                goBack();
            }
        });
};

const goBack = () => {
    if (isGuest.value) {
        $router.push({
            name: "job-listing-guest",
        });
    } else if(userRole === "locum") {
        $router.push({
            name: "profile",
        });
    } else {
        $router.push({
            name: "profile_job_seeker_setting",
        });
    }
};

const salaryRangeCheckboxChange = (value, event) => {
    form.salaryRange[value].minRate = null;
    disabledSalaryRange[value] = !event;
};

const countryArray = computed(() => {
    const region = process.env.VUE_APP_REGION;
    if (region === "US") return ["us"];
    if (region === "AU") return ["au"];
    return []; // Default or empty if region is not recognized
});

const setAddressData = (addressData, placeResultData) => {
    form.jobLocation.lat = placeResultData.geometry.location.lat();
    form.jobLocation.lng = placeResultData.geometry.location.lng();
    form.jobLocation.address = addressData.formatted_address;
};

const handleSalaryInput = (value, type) => {
    // Step 1: Remove non-numeric characters except for decimal point
    let sanitizedValue = value
        .replace(/[^0-9.]/g, ""); // Keep only numbers and decimal points

    // Step 2: Allow only one decimal point
    const parts = sanitizedValue.split(".");
    if (parts.length > 2) {
        sanitizedValue = `${parts[0]}.${parts.slice(1).join("")}`; // If more than one decimal, join the parts
    }

    // Step 3: Handle leading zeros
    if (sanitizedValue.length > 0) {
        sanitizedValue = sanitizedValue.replace(/^0+(?=\d)/, ""); // Remove leading zeros
    }

    // Step 4: Limit to two decimal places
    if (parts[1] && parts[1].length > 2) {
        sanitizedValue = `${parts[0]}.${parts[1].slice(0, 2)}`; // Keep only two decimal places
    }

    // Assign sanitized value to the respective minRate
    form.salaryRange[type].minRate = sanitizedValue;
};

const jobDistancePlaceholder = computed(() => {
    return `Set a search radius in ${messages.miles}`;
});

</script>
